import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-video-not-uploaded',
  templateUrl: './video-not-uploaded.component.html',
  styleUrls: ['./video-not-uploaded.component.scss']
})
export class VideoNotUploadedComponent implements OnInit {

  constructor(private activeModal: NgbActiveModal) { }

  @Input() public type;
  @Input() public message;
  ngOnInit() {
  }
  closeDialog() {
    this.activeModal.close();
  }
}
